"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import useElementId from "../../hooks/useElementId.js";
import { useFormControl } from "../FormControl/index.js";
import { classNames, responsiveClassNames } from "../../utilities/props.js";
import s from "./Select.module.css";
const SelectRoot = (passedProps) => {
    const formControl = useFormControl();
    const internalId = useElementId(passedProps.id);
    const props = {
        ...passedProps,
        id: formControl?.attributes?.id || passedProps.inputAttributes?.id || internalId,
        disabled: formControl?.disabled || passedProps.disabled,
        hasError: formControl?.hasError || passedProps.hasError,
        inputAttributes: { ...passedProps.inputAttributes, ...formControl?.attributes },
    };
    const { children, className, size = "medium", variant = "outline", hasError, disabled, attributes, } = props;
    const rootClassName = classNames(s.root, className, size && responsiveClassNames(s, "--size", size), hasError && s["--status-error"], disabled && s["--disabled"], variant && s[`--variant-${variant}`]);
    return (_jsx("div", { ...attributes, className: rootClassName, children: children(props) }));
};
export default SelectRoot;
